import Card from 'scripts/models/api/cards/base/card';

export default  Card.extend({
    title: {
        type: 'string',
        value: ''
    },
    description: {
        type: 'string',
        value: ''
    },
    targetUrl: {
        type: 'string',
        value: ''
    }
});